var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"download-container",on:{"click":function($event){return _vm.goto(_vm.url)}}},[_c('el-tooltip',{attrs:{"placement":"top"}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._v(" Download optimized video ")]),_c('font-awesome-icon',{staticClass:"icon-dowload",attrs:{"icon":"arrow-to-bottom"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }